export default "__VITE_ASSET__BdYUcCzE__"